const { defaultFeedSmartComponent } = require('client-v2/common/containers/feed/component-smart')

module.exports = defaultFeedSmartComponent.default
